export type SingleCharity = {
	code: string;
	description: string;
	id: string;
	logo: string;
	name: string;
	background: string;
};

const model: types.models.InputModel = {
	code: 'CyberSource_Code',
	description: 'description',
	id: 'id',
	logo: 'logo',
	name: 'name',
	background: 'background',
};

export default model;
